module.exports = __webpack_public_path__ + "static/media/team3.80c49dc4.jpg";